import {
    AdditionalFeesAllowed, ContractCurrency,
    FeeChargeability,
    ProductType,
} from 'app/enums/label.enums'
import {
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid'
import {
    StandardAdditionalFeesFilterRequestResponse,
} from 'app/requests/APricingRateCard/APricingRateCard.types'
import {
    FilterType,
} from 'app/enums/common.enums'

const columns: SkyDataGridColumnDefinition<
    StandardAdditionalFeesFilterRequestResponse
>[] = [
    {
        name: 'feeName',
        componentName: 'EnumValue',
        allowedValuesEnum: AdditionalFeesAllowed,
        labelKey: 'ADDITIONAL_FEE',
    },
    {
        name: 'feeChargability',
        componentName: 'EnumValue',
        allowedValuesEnum: FeeChargeability,
        labelKey: 'CHARGEABILITY',
    },
    {
        name: 'productType',
        componentName: 'EnumValue',
        allowedValuesEnum: ProductType,
        labelKey: 'PRODUCT_TYPE',
        width: 120,
    },
    {
        name: 'description',
        labelKey: 'A_QUOTE_DESCRIPTION',
    },
    {
        name: 'currency',
        componentName: 'EnumValue',
        allowedValuesEnum: ContractCurrency,
        filterField: 'currency',
        filterType: FilterType.Array,
        labelKey: 'CURRENCY',
        width: 115,
    },
    {
        name: 'feeValue',
        labelKey: 'AMOUNT',
        width: 115,
    },
]

export default columns
